import Platform from "../../../../../../libs/utility/Platform";
import { Theme } from "../../../../../components/constants";

export default {
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginBottom: "30px",
    },
    titleRow: {
        display: "flex",
        flexDirection: "row",
    },
    headerTitle: {
        display: "flex",
        flexDirection: "column",
    },
    titleSubTextContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        alignItems: "center"
    },
    titleSubText: {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "19px",
        color: Theme.DISABLED_TEXT,
    },
    recipientListContainer: {
        display: "flex",
        flexDirection: "column",
    },
    recipientListActionRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    recipientList: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "5px",
        paddingTop: "10px",
        gap: "20px",
        maxHeight: "35vh",
        overflow: "auto",
    },
    singleRecipientContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px",
        width: Platform.isMobileView() ? "100%" : "373px",
        height: "60px",
        position: "relative",
    },
    recipientInfo: {
        display: "flex",
        gap: "8px",
    },
    recipientCardCustomStyles: {
        padding: "10px 20px",
        cursor: "pointer",
        width: Platform.isMobileView() ? "100%" : "auto",
    },
    recipientLabel: {
        fontWeight: 400,
        fontSize: "20px",
        lineHeight: "24px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    recipientIdNUmberSpan: {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "16px",
        color: Theme.DISABLED_TEXT,
    },
    fontWeight600:{
        fontWeight:"600"
    },
    activeIconStyle: {
        top: "-10px", 
        right: "-10px"
    },
    recipientCardNextButton: {
        height:"100%",
        display:"flex", 
        alignItems:"flex-end", 
        justifyContent:"flex-end",
        position:"absolute",
        right:"0",
        bottom:"0", 
    },
    selectAndNextBtn:{
        fontSize: "14px",
        padding:"1px 15px"
    },
    searchAndAddNewRecipientContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "80px",
    }
}